export enum UserRoles {
  USER = "User",
  ORGANIZATION_ADMIN = "OrganizationAdmin",
  HIAB_ADMIN = "HiabAdmin",
}
